import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import {MODALS, fetchRoomAllocations} from 'ducks/tenancy';
import {fetchBooking} from 'ducks/bookings';

import {Buttons, RoomMoveForm} from './components';
import './styles.css';

class RoomMoveModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('roomMove');
  };

  getExtraActions = () => {
    const {tenancy, bookingId, locationRef} = this.props;

    return [
      ...this.props.closeModalExtraActions,
      () => fetchRoomAllocations({tenancyId: tenancy.id}),
      () => fetchBooking({bookingId, locationRef})
    ];
  };

  render() {
    const {
      form: {submitting},
      data: {checkedInAt, bookingType},
      locationRef,
      tenancy
    } = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.EXTRA_SMALL}
        className="RoomMoveModal">
        <Modal.Header heading="Create a Room Move" />
        <Modal.Body>
          <RoomMoveForm
            storeDataExtraActions={this.props.storeDataExtraActions}
            getExtraActions={this.getExtraActions}
            locationRef={locationRef}
            tenancy={tenancy}
            modalName={this.props.modalName}
            checkedInAt={checkedInAt}
            bookingType={bookingType}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            submitting={submitting}
            onClose={this.props.closeModal}
            submitForm={this.submitForm}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    form: {
      submitting: isSubmitting('roomMove')(state)
    }
  };
};
const mapDispatchToProps = {submit};

export default connect(mapStateToProps, mapDispatchToProps)(withModal(
  MODALS.ROOM_MOVE
)(RoomMoveModal) as React.ComponentType<any>);
